/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import BookingsCreateRoute from './create';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class EditRoute extends BookingsCreateRoute {
  controllerName = 'admin/bookings/create';
  templateName = 'admin/bookings/create';

  // Services
  @service
  store;

  model(params) {
    let bookingsModel = this.modelFor('admin.bookings');
    return hash({
      groups: bookingsModel.groups,
      staff: bookingsModel.staff,
      event: this.store.findRecord('bookings/event', params.event_id),
    });
  }
}
